import React from 'react';
import { useEffect } from 'react';
import { AuthContext } from '../../store/AuthContext';
import useFetch from '../hooks/useFetch';

import ItemMenu from './ItemMenu';

const Menu = ({ aberto }) => {
  const { data, loginUser, logout, newSession, login } =
    React.useContext(AuthContext);
  const { request, data: menusInfo, limpa: limpaMenus } = useFetch({});

  useEffect(() => {
    if (!login) {
      limpaMenus();
    }
  }, [login]);

  return (
    <></>
    /*<div className={`menu ${!aberto ? 'oculto' : ''}`}>
      <section>
        <h1>
          {process.env.REACT_APP_NAME} - {`v${process.env.REACT_APP_VERSION}`}
        </h1>
        {data ? (
          <a className="nome-usuario-logado aberto" tabIndex="1">
            {data.nome.toUpperCase()}
          </a>
        ) : (
          <a onClick={() => loginUser()}></a>
        )}

        <div className="dd-mobile">
          <a onClick={() => logout()} tabIndex="1">
            Sair
          </a>
          <a onClick={() => newSession()} tabIndex="2">
            Abrir nova sessão
          </a>
        </div>
      </section>

      <ItemMenu item={{ nome: 'Home', location: '/Principal' }} />
      <ItemMenu
        item={{ nome: 'Abrir Nova Sessão', location: '/abrirNovaSessao' }}
      />
      {menusInfo?.menus?.map((itemMenu) => (
        <ItemMenu key={itemMenu.nome} item={itemMenu} />
      ))}
    </div>*/
  );
};

export default Menu;
